G.Slider = function(x,y,width,initPos) {

	Phaser.Graphics.call(this,game,x,y);

	this.sliderWidth = width;
	this.pos = initPos;

	this.beginFill(0x000000,1);
	this.drawRect(0,-2,this.sliderWidth,4);

	this.circleGfx = this.addChild(game.make.graphics(width*initPos,0));
	this.circleGfx.clear();
	this.circleGfx.lineStyle(1, 0x000000, 1);
	this.circleGfx.beginFill(0x999999,1);
	this.circleGfx.drawCircle(0,0,32);
	this.circleGfx.sliderWidth = width;

	this.circleGfx.inputEnabled = true;
	this.circleGfx.input.useHandCursor = true;
	this.circleGfx.input.draggable = true;
	this.circleGfx.input.setDragLock(true, false);


};

G.Slider.prototype = Object.create(Phaser.Graphics.prototype);

G.Slider.prototype.update = function() {

	this.circleGfx.x = game.math.clamp(this.circleGfx.x,0,this.sliderWidth);
	this.pos = this.circleGfx.x/this.sliderWidth;

};